const addGlobalLabelsProps = (app) => {
    app.config.globalProperties.$labels = {
        getStatusLabel(value) {
            if (value) {
                switch(value.toUpperCase()) {
                    case 'ATIVO':
                        return 'Ativo'
                    case 'INATIVO':
                        return 'Inativo'
                }
            }
            return value;
        },
    }
}

const selectAtivoInativo = [
    { value: 'ATIVO', text: 'Ativo' },
    { value: 'INATIVO', text: 'Inativo' },
]

const toSelectOptionsTranslated = (apiOptions) => {
    let result = [];
    apiOptions.forEach(e => {
        result.push({
            value: e.value,
            text: e.text ? e.text : e.label
        })
    })
    return result;
}

export default addGlobalLabelsProps
export {
    selectAtivoInativo,
    toSelectOptionsTranslated
}
